export default __webpack_public_path__ + "static/media/portfolio.01e9f86e.PNG";